
import { MessageType, SystemEvent } from '@/common/bot/enum';
import { ResolutionMessageType, ResolutionType } from '@/common/bot/enum/ResolutionType';
import { BaseSystemMessage, ResolutionEvent, ResolutionMessage } from '@/common/bot/types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RESOLUTION_OPTIONS_POSITION, resolutionOptionsText } from './resolutionConfig';

/*
  This component is used to display a resolution message to the user.
  The user can choose between two options: "Yes" and "No".
  Customized text for these options is defined in the resolutionConfig file.
  The user's choice is sent to the bot as a ResolutionEvent.
*/
@Component({})
export default class ResolutionMessageComponent extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: BaseSystemMessage;

  get resolutionOptionText () {
    const messageType = this.message.type as unknown as ResolutionMessageType;
    return resolutionOptionsText(messageType);
  }

  get positionOptionText () {
    return this.resolutionOptionText[ResolutionType.YES];
  }

  get negativeOptionText () {
    return this.resolutionOptionText[ResolutionType.NO];
  }

  get resolutionOptionsPosition () {
    const messageType = this.message.type as unknown as ResolutionMessageType;
    const position = RESOLUTION_OPTIONS_POSITION[messageType];
    return position || RESOLUTION_OPTIONS_POSITION[MessageType.RESOLUTION]!;
  }

  handleResolve (message: ResolutionMessage, resolved: boolean) {
    const event: ResolutionEvent = {
      message,
      type: SystemEvent.USER_RESOLUTION_SELECTED,
      payload: { selected: resolved ? 'yes' : 'no' },
    };

    this.$emit('send:event', event);
  }
}
